import { Diagram } from "@interfaces/DiagramTypes";

export function getThumbnailUrl( diagram: Diagram | null ): string {
  if (diagram && diagram.fuid)
    return `/share-thumbnail/${diagram.fuid}/large/png`;
  return "";
}
